import { ComponentType } from 'react';

import { useNavigation } from '@atom/hooks/useNavigation';
import { ReportTypes } from '@atom/types/preferences';

import HidotOvertimeReport from './HidotOvertimeReport/HidotOvertimeReport';

const HIDOT_REPORTS: Partial<Record<ReportTypes, ComponentType>> = {
  [ReportTypes.HIDOT_REPORT_OVERTIME]: HidotOvertimeReport,
};

const HidotWorkOrderPdfReport = () => {
  const [, { params }] = useNavigation();
  const { reportType } = params;

  const Report = HIDOT_REPORTS[reportType as ReportTypes];

  return Report ? <Report /> : null;
};

export default HidotWorkOrderPdfReport;
